export interface IDatabaseMigration {
	upgrade(database: IDBDatabase, transaction: IDBTransaction): Promise<void> | void;
}

export class DatabaseMigrator {
	private readonly _migrations: ReadonlyArray<[number, IDatabaseMigration]>;

	constructor(migrations: ReadonlyArray<[number, IDatabaseMigration]>) {
		this._migrations = migrations;
	}

	public async migrate(
		database: IDBDatabase,
		transaction: IDBTransaction,
		from: number,
		to: number
	): Promise<void> {
		if (to < from) {
			throw new Error("Database downgrade is not supported");
		}

		if (to === from) {
			return;
		}
		const targetMigrationsWithVersions: [number, IDatabaseMigration][] = this._migrations
			.filter(m => m[0] > from && m[0] <= to);

		targetMigrationsWithVersions.sort((a, b) => a[0] - b[0]);

		const targetMigrations: ReadonlyArray<IDatabaseMigration> = targetMigrationsWithVersions.map(x => x[1]);

		for (const migration of targetMigrations) {
			await migration.upgrade(database, transaction);
		}
	}
}